<template>
  <!-- { component: data, colorIndex: selectedColor, optionIndex: selectedOption, variantIndex: selectedVariant })"> -->
  <button 
    class="button-wrapper" 
    style="position: relative"
    @click="$emit('select')" 
  >
    <InfoButton 
      v-if="data.infobox && data.infoboxOnline"
      minimized="true"
      @showspecs="infoboxID = data.infobox; enableAndHoldSpecs();"
    />
    <div class="card" :class="selected ? 'card-selected' : '' ">
      <div class="card-header">
        <!-- <img :src="`${previewsServer + models}previews/${data.code +  (data.options.length > 0 ? data.options[selectedOption].subCode : '')}.png`" alt="" @error="setBackupImage($event, data)"> -->
        <img :src="`${previewsServer + models}previews/${getCurrentImage}.png`" 
          alt="" @error="setBackupImage($event, data)">

        <!-- GLASS TYPES -->
        <!-- title = hover text over button -->
        <div class="card-header-glastypes" v-if="data.glasTypes && data.glasTypes.length > 0">
          <button 
            class="card-header-glastypes-button" 
            v-for="(glasType, index) in data.glasTypes" 
            :key="index" 
            :title="`${glasType.name} (${glasType.code})`"
            :class="cselected ? sglasType.code === glasType.code ? 'card-header-glastypes-button-active' : '' : index === selectedGlasType ? 'card-header-glastypes-button-active' : ''"
            @click="selectedGlasType = index; 
              selectedVariant = 0; 
              selectedColor = 0; 
              selectedOption = 0; 
              lastCodeSelection = glasType.code;
              $emit('select')"
            >
            <!-- {{ JSON.stringify(lastCodeSelection) }} -->
            <!-- ",{ 
              component: data, 
              glasTypeIndex: index, 
              variantIndex: 0, 
              colorIndex: 0, 
              optionIndex: 0 
              })" -->
          {{ glasType.acronym }}
          </button>
        </div>

        <!-- COLORS -->
        <!-- <div class="card-header-colors" v-if="data.colors.length > 0"> -->
          <!-- v-for="(color, index) in data.colors" -->
        <div class="card-header-colors" v-if="computeCurrentColors">
          <button 
            class="card-header-colors-button" 
            v-for="(color, index) in computeCurrentColors" 
            :key="index" 
            :title="`${color.name} (${color.code})`"
            :style="`background-color: ${color.hexCode};`"
            :class="cselected ? scolor.code === color.code ? 'card-header-colors-button-active' : '' : index === selectedColor ? 'card-header-colors-button-active' : ''"
            @click="selectedColor = index; 
            lastCodeSelection = color.code;
            $emit('select')"
          >
          <!-- { 
              component: data, 
              glasTypeIndex: selectedGlasType, 
              variantIndex: selectedVariant, 
              colorIndex: index, 
              optionIndex: selectedOption 
              })" -->
          </button>
        </div>
      </div>

      <!-- CARD INFO -->
      <!-- title = hover text over button -->
      <div class="card-info">
        <!-- <h3>{{ selectedColor > 0 ? data.colors[selectedColor].componentName : data.shortName }}</h3> -->
        <h3>{{ selectedColor > 0 ? 
          data.colors[selectedColor].componentName : selectedVariant > 0 ? 
          data.variants[selectedVariant].componentName : selectedGlasType > 0 ?
          data.glasTypes[selectedGlasType].componentName : data.shortName }}</h3>
        <div class="card-info-size">
          <mdicon class="card-info-size-icon" name="ruler-square" size="25" />
          <span class="card-info-size-text" >{{ data.size }} mm</span>
        </div>
      </div>

      <!-- VARIANTS -->
      <!-- <div class="card-options" v-if="data.variants && data.variants.length > 0"> -->
      <div class="card-options" v-if="computeCurrentVariants">        
        <button 
          v-for="(variant, index) in computeCurrentVariants" 
          :key="index"
          :class="cselected ? svariant.code === variant.code ? 'card-options-active' : '' : index === selectedVariant ? 'card-options-active' : ''"
          @click="selectedVariant = index; 
          selectedColor = 0; 
          selectedOption = 0; 
          lastCodeSelection = variant.code;
          $emit('select')"
          >
          <!-- ",{ 
            component: data, 
            glasTypeIndex: selectedGlasType,
            variantIndex: index, 
            colorIndex: 0, 
            optionIndex: 0 });"
        > -->
          {{ variant.name }}
        </button>
      </div>

      <!-- OPTIONS -->
      <!-- title = hover text over button -->
      <div class="card-options" v-if="data.options.length > 0">
        <button 
          v-for="(option, index) in data.options" 
          :key="index"
          :class="cselected ? soption.subCode === option.subCode ? 'card-options-active' : '' : index === selectedOption ? 'card-options-active' : ''"    
          @click="selectedOption = index; $emit('select')"
          >
          <!-- ,{ component: data, colorIndex: selectedColor, optionIndex: index })"
        > -->
          {{ option.name }}
        </button>
      </div>
    </div>
  </button>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-show="specsVisible"
        id="fullcoverForComponentCard"
        tabindex="-1"
        @click="specsVisible = false"
        @keydown.escape="specsVisible = false"
      >              
        <div 
          :class="onMobile ? 'modalspecs modalspecs-size-mobile' : 'modalspecs modalspecs-size'"
          @click.stop=""
        >
          <button 
            class="modalclosebutton" 
            @mouseover="specsCloseBtnMouseOver" 
            @mouseleave="specsCloseBtnMouseLeave"
            @click="specsVisible = false"
          >
            <Transition name="closebtn">
              <div 
                v-show="hasGlowingCloseBtn"
                class="absolutepos glowingclose"
              />
            </Transition>
            <div>
              ×
            </div>
          </button>
          <div class="imagescroller">
            <img 
              class="modalimage" 
              :src="`/infoboximages/${getFullInfoboxData?.urlEnding}`" 
              alt=""
            >
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { mapGetters } from 'vuex';
import InfoButton from '@/components/inputs/buttons/InfoButton.vue'

  export default {
    name: "ComponentCard",

    components: {
      InfoButton
    },
    props: {
      data: Object,
      selected: Boolean,
      cselected: Boolean,
      wSelected: Object, // selected wall data
      scolor: Object,
      soption: null,
      svariant: Object, // feature 1394
      sglasType: Object,
    },

    data () {
      // console.log('component card data',this.data)
      return {
        models: import.meta.env.VITE_VUE_APP_MODELS_LOCATION,
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
        selectedColor: 0,
        selectedOption: 0,
        selectedVariant: 0, // feature 1394
        selectedGlasType: 0, //
        lastCodeSelection: '', // for choosing .glb file
        onMobile: false,
        specsVisible: false,
        hasGlowingCloseBtn: false,
        infoboxID: null
      }
    },

    computed: {
      ...mapGetters({
        glassAndVariantsData: 'getGlassAndVariantsData',
        infoboxes: 'getInfoboxes'
      }),
      computeDataForThisGlassType() {
        let targetCode = '';
        if (this.selectedGlasType) {
          targetCode = this.data.glasTypes[this.selectedGlasType].code
          // console.log('test glassAndVariantsData',this.glassAndVariantsData)
          return this.glassAndVariantsData[this.curCategory()].glassVariants
            .find(item => (item.code === targetCode && item.variants));
        } else return null;
      },
      computeCurrentVariants() {
        // Find "related" data for glass types and their variants when selecting glass.
        if (this.selectedGlasType) {
          const curData = this.computeDataForThisGlassType;
          if (curData) { 
            return curData.variants; 
          } else return [];
        // Otherwise, show data.variants (if any)
        } else if (this.data.variants && this.data.variants.length > 0) {
          return this.data.variants;
        } else return [];
      },
      computeDataForThisVariant() {
        let targetCode = '';
        if (this.selectedVariant) {
          targetCode = this.data.variants[this.selectedVariant].code
          return this.glassAndVariantsData[this.curCategory()].variantColors
            .find(item => (item.code === targetCode && item.colors));
        } else return null;
      },
      computeCurrentColors() {
        // Find "related" data for variants and their colors when selecting variant.
        if (this.selectedVariant) {
          const curData = this.computeDataForThisVariant;
          if (curData) { return curData.colors; } else return [];
        // Otherwise, show data.colors (if any)
        } else if (this.data.colors && this.data.colors.length > 0) {
          return this.data.colors;
        } else return [];
      },      
      getCurrentImage() {
        let imgCode = this.data.code;
        // if(this.data.size === "845x2300") {
        //   console.log("getCurrentImage", this.selectedVariant, this.computeCurrentVariants.findIndex(v => v.code === this.svariant?.code))
        // }
        // React to glasstype
        if (this.selectedGlasType) {
          imgCode = this.data.glasTypes[this.selectedGlasType].code
        }
        // React to variant
        if (this.selectedVariant) {
        // if (this.selectedVariant !== null && this.selectedVariant !== undefined && this.data.variants && this.data.variants[this.selectedVariant]) {
          imgCode = this.data.variants[this.selectedVariant].code
        }
        // if (this.computeCurrentVariants.findIndex(v => v.code === this.svariant?.code) > -1) {
        //   imgCode = this.data.variants[this.computeCurrentVariants.findIndex(v => v.code === this.svariant?.code)].code
        // }
        // if(this.selected) {
        //   if (this.computeCurrentVariants.findIndex(v => v.code === this.svariant?.code) > -1) {
        //     imgCode = this.data.variants[this.computeCurrentVariants.findIndex(v => v.code === this.svariant?.code)].code
        //   }
        // } else {
        //   if (this.selectedVariant) {
        //     imgCode = this.data.variants[this.selectedVariant].code
        //   }
        // }
        // React to subcode
        if (this.data.options.length > 0) imgCode += this.data.options[this.selectedOption].subCode
        // console.log('imgCode',imgCode)
        return imgCode;
      },      
      getFullInfoboxData() {
        return this.infoboxes.find(info => info.id === this.infoboxID)
      }
    },

    watch: {
      wSelected: "setCurrentComponentSettings",
    },

    created() {
      let regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      this.onMobile = regex.test(navigator.userAgent)
      this.$nextTick(() => {
          document.getElementById('fullcoverForComponentCard')
            .addEventListener('click', function (/*event*/) {
                // console.log('TEST',event)
            });
        })
    },

    mounted() {
      this.setCurrentComponentSettings()
    },

    methods: {
      setBackupImage(e, data) {
        e.target.src = `https://fakeimg.pl/400x400/?text=${data.code +  (data.options.length > 0 ? data.options[this.selectedOption].subCode : '')}&font=bebas`
      },
      curCategory() {
        // Find current category (for use in this.glassAndVariantsData.???.glassVariants etc)
        let result;
        switch(this.data.category) {
          case 'Deur': result = 'basicDoors'; break;
          case 'Raam': result = 'basicWindows'; break;          
          case 'Steellook Deur': result = 'steellookDoors'; break;
          case 'Steellook Raam': result = 'steellookWindows'; break;
          case 'Steellook Raam BW': result = 'steellookWindowsBW'; break;
          case 'Steellook': result = 'steellook'; break;
          case 'Steellook Wand BW': result = 'steellookWandBW'; break;
          case 'Schuifwand': result = 'slidingwall'; break;
        }
        return result;
      },

      setCurrentComponentSettings() {
        const colorIndex = this.computeCurrentColors.findIndex(item => item.code === this.scolor?.code);
        if(colorIndex > -1) this.selectedColor = colorIndex;
        const optionIndex = this.data.options ? this.data.options.findIndex(item => item.subCode === this.soption?.subCode) : -1;
        if(optionIndex > -1) this.selectedOption = optionIndex;
        const variantIndex = this.computeCurrentVariants.findIndex(item => item.code === this.svariant?.code);
        if(variantIndex > -1) this.selectedVariant = variantIndex;
        const glasTypeIndex = this.data.glasTypes ? this.data.glasTypes.findIndex(item => item.code === this.sglasType?.code) : -1;
        if(glasTypeIndex > -1) this.selectedGlasType = glasTypeIndex;
      },

      specsCloseBtnMouseOver() {
        this.hasGlowingCloseBtn = true;
      },
      specsCloseBtnMouseLeave(){
        this.hasGlowingCloseBtn = false;
      },
      enableAndHoldSpecs() {
        this.specsVisible = !this.specsVisible;
        if (this.specsVisible) {
          this.$nextTick(() => {
            document.getElementById('fullcoverForComponentCard')?.focus();
          });
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

.card {
  display: flex;
  flex-grow: 1;
  height: calc(100% - 20px);
  flex-direction: column;
  outline: 3px solid $c-border-1;
  border-radius: $radius-m;
  padding: 10px;
  transition: outline-color 100ms ease;
  border: none;
  background-color: transparent;
  scroll-margin: 150px;

  &:hover {
    outline-color: $c-secondary;
    cursor: pointer;
  }

  &-selected {
    outline-color: $c-secondary;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    height: 150px;
    max-width: 100%;

    & img {
      min-height: 150px;
      max-height: 150px;
      width: calc(100% - 24px);
      object-fit: contain;
    }

    &-colors {
      display: flex;
      flex-direction: column;
      gap: 6px;

      &-button {
        height: 24px;
        width: 24px;
        outline: 3px solid $c-border-1;
        outline-offset: -2px;
        border: none;
        border-radius: $radius-s;
        transition: outline-color 100ms ease;
        cursor: pointer;

        &:hover {
          outline-color: $c-secondary;
        }

        &-active {
          outline-color: $c-secondary;
        }
      }
    }

    &-glastypes {
      display: flex;
      flex-direction: column;
      gap: 6px;

      &-button {
        height: 24px;
        width: 32px;
        outline: 3px solid $c-border-1;
        outline-offset: -2px;
        border: none;
        border-radius: $radius-s;
        transition: outline-color 100ms ease;
        cursor: pointer;
        margin-right: 0.4em;

        &:hover {
          outline-color: $c-secondary;
        }

        &-active {
          outline-color: $c-secondary;
        }        
      }
    }
  }

  &-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;

    & h3 {
      font-size: 1rem;
      text-align: left;
    }

    &-size {
      display: flex;
      align-items: center;
      gap: 15px;
      font-weight: 500;
    }
  }

  &-options {
    display: flex;
    gap: 15px;

    & button {
      flex-grow: 1;
      background-color: $c-background-1;
      border: none;
      border-radius: $radius-s;
      padding: 5px;
      font-weight: 600;
      font-size: 0.9rem;
      color: $c-primary;
      transition: color 100ms ease, background-color 100ms ease;
      cursor: pointer;
    }

    &-active {
      background-color: $c-primary !important;
      // color: $c-secondary  !important;
      color: $c-secondary-bright  !important;
    }
  }
}

.button-wrapper {
  border: none;
  display: flex;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
}

#fullcoverForComponentCard {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modalspecs {
  position: fixed;
  z-index: 999;
  left: 50%;
  background-color: white;
  border-radius: $radius-s;
}
.modalspecs-size {
    top: 3%;
    width: 36rem;
    margin-left: -18rem;
    height: 94vh;
 }
.modalspecs-size-mobile {
    top: 10%;
    width: 98%;
    margin-left: -49%;
    height: 80vh;
 }

.modaltopcontainer {
  display: flex; text-align: start; height: 8vh
}
.modaltopcontainer h3 {
  margin: 1.5vh 1.5vh 1.5vh 3vh;
}

.imagescroller {
  max-height: calc(98%);
  overflow-y: auto;
  border-radius: $radius-m;
}
.modalimage {
  width: 100%;
  height: auto;
}

.modalclosebutton {
  position: absolute;
  top: 32px;
  right: 48px;
  height: 4vh;
  width: 4vh;
  background: transparent;
  color: white;
  border: 2px solid white;
  box-sizing: border-box;
  border-radius: 3vh;
  font-size: 4vh;
  pointer-events: all;
  cursor: pointer;
  // force the × to stay centered despite resizing
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;

  &:hover {
    background-color: rgba(255, 255, 15, 0.75);
  }
}

.glowingclose {
  border-radius: 20px;
}

</style>